<template>
    <v-container v-resize="onResize">
        <v-layout row wrap>
            <v-flex sm12 lg5 xl6>
                <v-card v-if="data != null && data.Question" class="mt-0 pa-1">
                    <v-card-title style="max-height: 52px;">
                        <h2 class="title font-weight-bold" style="font-size: 1.75rem !important;">{{ data.Title }}</h2>
                    </v-card-title>
                    <v-card-text class="pt-0 pb-0">
                        <v-layout row wrap>
                            <v-flex xs12 md8 lg12 xl8 class="pr-md-4 pr-xl-5">
                                <h3>Question:</h3>
                                <div v-html="data.Question"></div>
                                <h3 class="pb-4">
                                    Result: <v-icon aria-hidden="true" class="ml-1" :color="data.Carried ? 'green darken-2' : 'red darken-2'">
                                        {{ data.Carried ? 'check_circle' : 'cancel' }}
                                    </v-icon> {{ data.Carried ? 'Carried' : 'Not carried' }}
                                    <span class="pl-3 font-weight-regular" v-if="data.StateMajority != 0">States voting yes: {{data.StateMajority}}</span>
                                    <span class="pl-3 font-weight-regular">Total yes votes: {{data.VoteMajority}}%</span>
                                </h3>
                            </v-flex>
                            <v-flex xs12 md4 lg12 xl4 class="pr-4 pl-xl-0 pt-0">
                                <h3>Date: {{ data.Date | stringDateFormat }}</h3>
                                <br />
                                <v-layout row wrap>
                                    <v-flex sm6 md6 lg5>
                                        <Portrait v-bind:PHID="data.PrimeMinister.Phid" :fixedWidth="80"></Portrait>
                                        <h4>Prime Minister:<br />{{data.PrimeMinister.DisplayName}}</h4>
                                        <h5>{{data.PrimeMinister.Party}}</h5>
                                        <br />
                                    </v-flex>
                                    <v-flex sm6 md6 lg7>
                                        <Portrait v-bind:PHID="data.LeaderOfOpposition.Phid" :fixedWidth="80"></Portrait>
                                        <h4>Leader of the Opposition:<br />{{data.LeaderOfOpposition.DisplayName}}</h4>
                                        <h5>{{data.LeaderOfOpposition.Party}}</h5>
                                        <br />
                                    </v-flex>
                                </v-layout>

                            </v-flex>
                        </v-layout>
                        <v-flex sm12 class="fill-height hidden-print-only">
                            <div class="pb-2" v-if="data != null && data.ReferendumType == 'Referendum'">
                                <v-btn v-if="data.IntroducedLink != null" :color="data.IntroducedLink.indexOf('hansardr') > -1 ? 'green darken-3' : 'red darken-4'" class="ml-0" style="text-transform: none; border-radius: 5px;" :href="data.IntroducedLink" target="_blank">
                                    <span style="color: white" v-if="data.IntroducedLink.indexOf('hansardr') > -1">First introduced in House</span>
                                    <span style="color: white" v-if="data.IntroducedLink.indexOf('hansards') > -1">First introduced in Senate</span>
                                </v-btn>

                                <v-btn v-if="data.SenateVoteLink != null" color="red darken-4" style="text-transform: none; border-radius: 5px;" :href="data.SenateVoteLink" target="_blank">
                                    <span style="color: white">Third reading vote in Senate</span>
                                </v-btn>

                                <v-btn v-if="data.HouseVoteLink != null" color="green darken-3" style="text-transform: none; border-radius: 5px;" :href="data.HouseVoteLink" target="_blank">
                                    <span style="color: white">Third reading vote in House</span>
                                </v-btn>

                                <v-btn v-if="data.BillLink != null" color="primary" style="text-transform: none; border-radius: 5px;" :href="data.BillLink" target="_blank">
                                    <span>Bill</span>
                                </v-btn>
                            </div>
                        </v-flex>
                    </v-card-text>
                </v-card>
            </v-flex>

        </v-layout>
        <br />
        <loader v-if="loading" />
        <v-layout row wrap>
            <v-flex sm12>
                <h2 v-if="!loading">{{this.convertStateAbbreviationToState(this.state)}} results</h2>
            </v-flex>
            <v-menu v-if="this.isMobile" d-inline offset-y :nudge-left="140" style="float:right" :close-on-content-click="true">
                <v-btn outline small slot="activator">
                    Sort <v-icon>sort</v-icon>
                </v-btn>
                <v-list>
                    <v-subheader>
                        Sort by:
                    </v-subheader>
                    <v-list-tile v-for="(item, index) in headers.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                        <v-list-tile-title>
                            {{ item.text }}
                            <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                        </v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-layout>
        <br />
        <v-data-table v-if="!loading"
                      :headers="headers"
                      :pagination.sync="PAGINATION"
                      :hide-actions="true"
                      :hide-headers="isMobile || isPrint"
                      :class="{ mobileDataTable: isMobile || isPrint, 'elevation-1': true }"
                      :items="data.Results">

            <template v-slot:items="props">
                <tr>
                    <template v-if="isMobile || isPrint">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item"><h3 class="pt-2 pb-xs-0">{{ props.item.Division }}</h3></div>
                                <div class="flex-item flex-item-col  flex-item-col-40" data-label="For">{{ props.item.ForPercentage }}% ({{ props.item.ForVotes | commas }})</div>
                                <div class="flex-item flex-item-col flex-item-col-60 " data-label="Against">{{ props.item.AgainstPercentage }}% ({{ props.item.AgainstVotes | commas }})</div>
                                <div class="flex-item px-2"><v-divider></v-divider></div>
                                <div class="flex-item flex-item-col flex-item-col-40" data-label="Votes">{{ props.item.VotesPercentage }}% ({{ props.item.Votes | commas }})</div>
                                <div class="flex-item flex-item-col flex-item-col-30" data-label="Enrolled">{{ props.item.Enrolled | commas }}</div>
                                <div class="flex-item flex-item-col flex-item-col-30" data-label="Informal">{{ props.item.InformalPercentage }}% ({{ props.item.InformalVotes | commas }})</div>
                            </div>
                        </td>
                    </template>
                    <template v-else>
                        <td class="text-xs-left">
                            {{ props.item.Division }}
                        </td>
                        <td class="text-xs-left">{{ props.item.ForPercentage }}% </td>
                        <td class="text-xs-left">{{ props.item.ForVotes | commas }}</td>
                        <td class="text-xs-left">{{ props.item.AgainstPercentage }}%</td>
                        <td class="text-xs-left">{{ props.item.AgainstVotes | commas }}</td>
                        <td class="text-xs-left" style="border-left: 1px solid #d9d9d9;">{{ props.item.Enrolled | commas }}</td>
                        <td class="text-xs-left">{{ props.item.VotesPercentage }}% ({{ props.item.Votes | commas }})</td>
                        <td class="text-xs-left">{{ props.item.InformalPercentage }}% ({{ props.item.InformalVotes | commas }})</td>
                    </template>
                </tr>
            </template>
        </v-data-table>
        <br />
        <v-layout row wrap class="hidden-print-only">
            <v-flex xs12>
                <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                    <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                    <span>&nbsp;Download CSV</span>
                </v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import print from '../../mixins/print';
    import Loader from '@/components/Loader.vue';
    import axios from 'axios';
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;
    import Portrait from '@/components/Portrait.vue'

    export default {
        props: ['id', 'state'],
        mixins: [print],
        components: {
            Loader,
            Portrait
        },
        created() {
            this.initialiseData();
        },
        mounted() {
            this.onResize();
        },
        data() {
            return {
                data: [],
                isMobile: false,
                loading: true,
                csvDownloading: false,
                PAGINATION: {
                    rowsPerPage: 999,
                    sortBy: 'Division',
                    descending: false
                },
                headers: [
                    {
                        text: 'Division',
                        value: 'Division'
                    },
                    {
                        text: 'For (%)',
                        align: 'left',
                        value: 'ForPercentage'
                    },
                    {
                        text: 'For (votes)',
                        align: 'left',
                        value: 'ForVotes'
                    },
                    {
                        text: 'Against (%)',
                        align: 'left',
                        value: 'AgainstPercentage'
                    },
                    {
                        text: 'Against (votes)',
                        align: 'left',
                        value: 'AgainstVotes'
                    },
                    {
                        text: 'Enrolled',
                        align: 'left',
                        value: 'Enrolled'
                    },
                    {
                        text: 'Votes (%)',
                        align: 'left',
                        value: 'VotesPercentage'
                    },
                    {
                        text: 'Informal (%)',
                        align: 'left',
                        value: 'InformalPercentage'
                    }
                ]
            }
        },
        computed: {
            csvDownloadIcon() {
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass() {
                let csvClass = 'mr-1';
                if (this.csvDownloading) {
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            }
        },
        methods: {
            initialiseData: function () {
                this.loading = true;
                const url = `Referendums/ReferendumStateDivisions?id=${this.id}&state=${this.state}`;
                axios.get(`api/${url}`)
                    .then(response => {
                        this.data = response.data;
                        this.loading = false;
                    });
            },
            onResize() {
                if (window.innerWidth < 1069) {
                    this.isMobile = true;
                }
                else {
                    this.isMobile = false;
                }
            },
            changeSort(column) {
                if (this.PAGINATION.sortBy === column) {
                    this.PAGINATION.descending = !this.PAGINATION.descending
                }
                else {
                    this.PAGINATION.sortBy = column
                    this.PAGINATION.descending = false
                }
            },
            exportCsv() {
                this.$gtag.event('referendum download csv', {
                    'event_category': 'downloads',
                    'event_label': `referendum csv download`,
                    'value': 1
                });

                this.csvDownloading = true;
                let headers = ['State'];
                let filename = this.data.Title + " - (" + this.data.ReferendumType + ") " + this.state.toUpperCase() + " results";

                if (this.data.Options != null && this.data.Options.length > 0) {
                    this.data.Options.forEach(o => {
                        headers.push(o);
                    });

                    headers.push('Enrolled');
                    headers.push('Total votes');
                    headers.push('Informal votes');

                    var records = this.data.Results.map(r => ({
                        'Division': r.Division,
                        'Total votes': r.Votes,
                        'Informal votes': r.InformalVotes,
                        'Options': r.OptionVotes
                    }));

                    records.forEach(r => {
                        r.Options.forEach(o => {
                            r[o.Option.toString()] = o.Votes
                        })
                        r.Options = null;
                        delete r.Options;
                    })


                    this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename })
                        .catch(this.showError)
                        .finally(() => this.csvDownloading = false);
                }
                else {
                    let records = this.data.Results.map(r => ({
                        'Division': r.Division,
                        'For votes': r.ForVotes,
                        'Against votes': r.AgainstVotes,
                        'Enrolled': r.Enrolled,
                        'Total votes': r.Votes,
                        'Informal votes': r.InformalVotes
                    }));

                    this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename })
                        .catch(this.showError)
                        .finally(() => this.csvDownloading = false);
                }
            }
        }
    }

</script>
